import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationType } from '@core/constants/notifications';
import { NotificationData } from '@app/shared/models/notification-data.model';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false,
})
export class NotificationComponent {
    type: NotificationType;
    message: string;
    icon: string;

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: NotificationData) {
        this.type = data.type;
        this.message = data.message;
        this.icon = this.getIcon();
    }

    private getIcon(): string {
        const icons = {
            [NotificationType.Error]: 'error',
            [NotificationType.Warning]: 'warning',
            [NotificationType.Success]: 'check_circle',
            [NotificationType.Default]: 'info',
        };

        return icons[this.type];
    }
}
